"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var HourglassOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_HourglassOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 12,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.224 9.553a.5.5 0 1 0-.448.894c.274.137.94.605 1.277 1.277a.5.5 0 1 0 .894-.448c-.464-.928-1.33-1.527-1.723-1.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 .5a.5.5 0 0 0 .5.5H3v2.429c0 1.586.698 3.005 1.796 3.948A5 5 0 0 0 5.707 8a5 5 0 0 0-.911.623A5.191 5.191 0 0 0 3 12.571V15h-.5a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1H13v-2.429a5.191 5.191 0 0 0-1.796-3.948c-.28-.24-.585-.45-.911-.623.326-.174.632-.383.911-.623A5.191 5.191 0 0 0 13 3.429V1h.5a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5Zm2 2.929V1h8v2.429c0 1.616-.892 3.005-2.177 3.688l-1.165.62a.298.298 0 0 0 0 .526l1.165.62C11.108 9.566 12 10.955 12 12.57V15H4v-2.429c0-1.616.892-3.005 2.177-3.688l1.165-.62a.298.298 0 0 0 0-.526l-1.165-.62C4.892 6.434 4 5.045 4 3.429Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_HourglassOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = HourglassOutline;
exports["default"] = _default;